// blogPosts.js
export const blogPosts = [
  {
    id: "holistic-scaling-wellness-business",
    title: "Scaling Your Wellness Business Without Burning Out",
    date: "June 25, 2025",
    excerpt: "A heart-centered approach to growing your coaching practice with ease, alignment, and sustainability.",
    content: `
### 1. Align Your Offer With Your Energy

Let go of constant hustle. Design offers like group coaching or digital programs that serve deeply — without draining you.

### 2. Nurture Your Community with Intention

Focus on real connection: email, private chat spaces, and personal touch points. A nurtured audience converts with ease.

### 3. Use Smart Systems (Like Nouriv)

Automations don't replace care — they *amplify* it. With the right systems, you can show up consistently without being online 24/7.
    `,
  },
  {
    id: "magnetic-client-language",
    title: "Magnetic Messaging for Wellness Coaches",
    date: "June 12, 2025",
    excerpt: "Your words shape your brand energy. Here’s how to communicate with clarity and soul.",
    content: `
### 1. Paint the Vision

Speak directly to the life your clients crave — not just their current struggles.

### 2. Reflect Their Words Back

Use real client language from calls or feedback. It builds instant trust and resonance.

### 3. Stand in Your Power

You don’t have to be louder. Just clearer. Speak with grounded confidence and aligned conviction.
    `,
  },
];
